import {HttpHeaders} from '@angular/common/http';
import {
  Configuration,
  GetNameValueListResponse,
  GetNameValueResponse,
  GetNameValuesResponse,
  ListEntry,
  NameValueServiceInterface,
  Response
} from '@gt-api';
import {Observable, of} from 'rxjs';

export class NameValueServiceStub implements NameValueServiceInterface {
  defaultHeaders: HttpHeaders = new HttpHeaders();
  configuration: Configuration;

  getDepartmentNameValue1(name: string, organization?: string, departmentId?: number): Observable<GetNameValueResponse> {
    return of({code: 200, value: ''});
  }

  getDepartmentNameValueList1(name: string, organization?: string, departmentId?: number): Observable<GetNameValueListResponse> {
    return of({code: 200, entries: []});
  }

  getEndUserNameValue1(name: string, organization?: string, login?: string): Observable<GetNameValueResponse> {
    let value;
    switch (name) {
      case 'DisplayNumberProfile':
        value = '2';
        break;
      case 'ActiveProfilePrivate':
        value = '4';
        break;
      case 'ActiveProfile':
        value = '5';
        break;
      case 'ActiveProfileOOO':
        value = '8';
        break;
      default:
        value = 'test';
        break;
    }

    return of({code: 200, value});
  }

  getEndUserNameValueList1(name: string, organization?: string, login?: string): Observable<GetNameValueListResponse> {
    return of({code: 200, entries: []});
  }

  getEndUserNameValues1(organization?: string, login?: string, names?: Array<string>): Observable<GetNameValuesResponse> {
    return of({code: 200, nameValues: {}});
  }

  setDepartmentNameValue1(name: string, value: string, organization?: string, departmentId?: number): Observable<Response> {
    return of({code: 200});
  }

  setDepartmentNameValueList1(name: string, organization?: string, departmentId?: number, body?: Array<ListEntry>): Observable<Response> {
    return of({code: 200});
  }

  setEndUserNameValue1(name: string, value: string, organization?: string, login?: string): Observable<Response> {
    return of({code: 200, exception: '', message: 'ok'});
  }

  setEndUserNameValueList1(name: string, organization?: string, login?: string, body?: Array<ListEntry>): Observable<Response> {
    return of({code: 200});
  }

  setEndUserNameValues1(organization?: string, login?: string, body?: any): Observable<Response> {
    return of({code: 200});
  }
}
